module.exports = require('./runkit').default


// WEBPACK FOOTER //
// ./src/index.js